import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getChannel, getUserCreatedChannel } from "../../api/channels/channelServices";
import { getFeedback } from "../../api/feedback/feedbackServices";
import { SKFeedback } from "../../models/SKFeedback";
import { format } from "date-fns";
import { capitalizeFirstLetter } from "../../utils/stringFunctions";
import APILoader from "../../components/APILoader";
import { useNavigationBar } from "../../context/NavigationContext";

const FeedbackDetail = () => {
  const { type, id } = useParams();
  const { setNavProps } = useNavigationBar();
  const navigate = useNavigate();
  const [feedback, setFeedback] = useState<SKFeedback | undefined>(undefined);

  useEffect(() => {
    setNavProps({
      backArrow: false,
      title: capitalizeFirstLetter(feedback?.type ?? "--"),
      subtitle: feedback?.id ?? "--",
      buttonTitle: "Close",
      enableLink: false,
      onNext: () => {
        // navigate(1);
      },
      onClose: () => {
        navigate(-1);
      },
    });
  }, [feedback, navigate, setNavProps]);

  useEffect(() => {
    const fetchFeedback = async (id: string) => {
      if (type === "issue" || type === "suggestion") {
        const statusList = await getFeedback(id, type);
        console.log(JSON.stringify(statusList));
        setFeedback(statusList);
      } else {
        throw new Error("Invalid feedback type");
      }
    };
    if (id) {
      fetchFeedback(id);
    }
  }, [id]);

  return feedback ? (
    <div className="flex flex-col gap-[10px] mt-[15px]">
      <div className="relative w-full">
        <div className="flex flex-col w-full">
          <div>
            <p className="history-date">Date Submitted</p>
          </div>
          <div>
            <p className="history-status">{feedback?.feedbackDate ? format(feedback?.feedbackDate.toDate(), "MMM, dd yyyy hh:mm a") : "--"}</p>
          </div>
        </div>
        <div className="thinseparator mt-[10px]" />
      </div>
      <div className="relative w-full">
        <div className="flex flex-col w-full">
          <div>
            <p className="history-date">Category</p>
          </div>
          <div>
            <p className="history-status">{feedback?.category ?? "--"}</p>
          </div>
        </div>
        <div className="thinseparator mt-[10px]" />
      </div>
      <div className="relative w-full">
        <div className="flex flex-col w-full">
          <div>
            <p className="history-date">Issue</p>
          </div>
          <div>
            <p className="history-status">{feedback?.message ?? "--"}</p>
          </div>
        </div>
        <div className="thinseparator mt-[10px]" />
      </div>
      <div className="relative w-full">
        <div className="flex flex-col w-full">
          <div>
            <p className="history-date">Issue ID</p>
          </div>
          <div>
            <p className="history-status">{feedback?.id ?? "--"}</p>
          </div>
        </div>
        <div className="thinseparator mt-[10px]" />
      </div>
      <div className="relative w-full">
        <div className="flex flex-col w-full">
          <div>
            <p className="history-date">Type</p>
          </div>
          <div>
            <p className="history-status">{feedback?.type ?? "--"}</p>
          </div>
        </div>
        <div className="thinseparator mt-[10px]" />
      </div>
      <div className="relative w-full">
        <div className="flex flex-col w-full">
          <div>
            <p className="history-date">User ID</p>
          </div>
          <div>
            <p className="history-status">{feedback?.userID ?? "--"}</p>
          </div>
        </div>
        <div className="thinseparator mt-[10px]" />
      </div>{" "}
      <div className="relative w-full">
        <div className="flex flex-col w-full">
          <div>
            <p className="history-date">User Phone</p>
          </div>
          <div>
            <p className="history-status">{feedback?.phone ?? "--"}</p>
          </div>
        </div>
        <div className="thinseparator mt-[10px]" />
      </div>{" "}
      <div className="relative w-full">
        <div className="flex flex-col w-full">
          <div>
            <p className="history-date">OS Version</p>
          </div>
          <div>
            <p className="history-status">
              {feedback?.osType ?? "--"} - V-{feedback?.osVersion ?? "--"}
            </p>
          </div>
        </div>
        <div className="thinseparator mt-[10px]" />
      </div>{" "}
      <div className="relative w-full">
        <div className="flex flex-col w-full">
          <div>
            <p className="history-date">App Version</p>
          </div>
          <div>
            <p className="history-status">{feedback?.appVersion ?? "--"}</p>
          </div>
        </div>
        <div className="thinseparator mt-[10px]" />
      </div>
    </div>
  ) : (
    <>
      <APILoader loading={true} />
    </>
  );
};

export default FeedbackDetail;
